import axios from "axios";
import { uploadTOS3BucketUrl } from "../../services/CourseService";

/**
 * Browser upload via Admin API presigned PUT.
 *
 * @param {Array<{file_name: string, file_type: string}>} files - object keys + content types
 * @param {File|File[]} fileListData - single File or File list matching `files`
 * @param {{ storageProvider?: string }} [options]
 *   storageProvider: "1" = AWS S3 (default, legacy callers), "2" = Cloudflare R2 (Add Attachment)
 */
export const handleUploadToS3BucketUrl = async (files, fileListData, options = {}) => {
  if (!files || files.length === 0) return;

  try {
    const formData = new FormData();
    formData.append("uploadFiles", JSON.stringify(files));
    // Phase 2 write: optional provider for R2 Add Attachment; omit → API defaults to S3
    if (options.storageProvider != null && options.storageProvider !== "") {
      formData.append("storageProvider", String(options.storageProvider));
    }

    const response = await uploadTOS3BucketUrl(formData);
    const uploadURLList = response.data?.data || [];

    if (!uploadURLList.length || uploadURLList.length !== files.length) {
      throw new Error("Mismatch in number of files and upload URLs");
    }

    const uploadedFileKeys = [];

    if ((Array.isArray(fileListData) && fileListData.length > 0) || (typeof fileListData === 'object' && fileListData !== null && fileListData?.length > 1)) {
      // const filesData = fileListData.map(item => item.file);

      for (let i = 0; i < fileListData.length; i++) {
        const file = fileListData[i];
        const uploadURL = uploadURLList[i]?.uploadURL;
        const fileKey = uploadURLList[i]?.fileKey;

        if (!file || !uploadURL) continue;

        const uploadResponse = await axios.put(uploadURL, file, {
          headers: {
            "Content-Type": file.type,
          },
        });

        if (uploadResponse.status === 200) {
          uploadedFileKeys.push({
            path: fileKey,
            size: file.size,
            absolutePath: uploadURL,
            storageProvider: uploadURLList[i]?.storageProvider,
          });
        } else {
          throw new Error(`Upload failed for ${file.name} with status ${uploadResponse.status}`);
        }
      }
    } else {
      // Single file fallback
      const uploadURL = uploadURLList[0]?.uploadURL;
      const fileKey = uploadURLList[0]?.fileKey;

      const uploadResponse = await axios.put(uploadURL, fileListData, {
        headers: {
          "Content-Type": fileListData?.type,
        },
      });

      if (uploadResponse.status === 200) {
        uploadedFileKeys.push({
          path: fileKey,
          size: fileListData?.size,
          absolutePath: uploadURL,
          storageProvider: uploadURLList[0]?.storageProvider,
        });
      } else {
        // throw new Error(`S3 upload failed with status: ${uploadResponse.status}`); // AWS S3-only
        throw new Error(`Object storage upload failed with status: ${uploadResponse.status}`);
      }
    }

    return uploadedFileKeys;
  } catch (error) {
    console.error("Error in file upload:", error);
    throw error;
  }
};
